<script setup lang="ts">
import {useAuthStore} from "~~/stores/auth";

const auth = useAuthStore()
const { t } = useI18n()
const localePath = useLocalePath()

const items = [
    {
        label: t('forParents.question_1.question'),
        content: '<ol class="list-decimal text-[#012C3B]"><li class="ml-5 mb-2">' + t('forParents.question_1.answer_1') + '</li><li class="ml-5 mb-2">' + t('forParents.question_1.answer_2') + '</li><li class="ml-5 mb-2">' + t('forParents.question_1.answer_3') + '</li><li class="ml-5 mb-2">' + t('forParents.question_1.answer_4') + '</li><li class="ml-5 mb-2">' + t('forParents.question_1.answer_5') + '</li><li class="ml-5">' + t('forParents.question_1.answer_6') + '</li></ol>',
    },
    {
        label: t('forParents.question_2.question'),
        content: '<p class="text-[#012C3B]">' + t('forParents.question_2.answer') + '</p>',
    },
    {
        label: t('forParents.question_3.question'),
        content: '<ul class="list-image-[url(\'/images/for-parents/bullet.svg\')] text-[#012C3B]"><li class="ml-5 mb-2">' + t('forParents.question_3.answer_1') + '</li><li class="ml-5 mb-2">' + t('forParents.question_3.answer_2') + '</li><li class="ml-5 mb-2">' + t('forParents.question_3.answer_3') + '</li><li class="ml-5 mb-2">' + t('forParents.question_3.answer_4') + '</li><li class="ml-5">' + t('forParents.question_3.answer_5') + '</li></ul>',
    },
    {
        label: t('forParents.question_4.question'),
        content: '<p class="text-[#012C3B] mb-2">' + t('forParents.question_4.answer_1') + '</p><p class="text-[#012C3B] mb-2">' + t('forParents.question_4.answer_2') + '</p><p class="text-[#012C3B]">' + t('forParents.question_4.answer_3') + '</p>',
    },
];

const openItems = ref('0')

</script>

<template>
    <section class="sm:pt-24 relative overflow-x-clip">
        <NuxtImg src="/images/for-parents/for-parents-bg-top-mobile.svg" alt="Top background" class="md:hidden w-full h-auto -mb-[1px]" />
        <NuxtImg src="/images/for-parents/for-parents-bg-top.svg" alt="Top background" class="hidden md:block w-full h-auto -mb-[1px]" />
        <div class="bg-[#edf7fa] py-12">
            <UContainer>
                <div class="grid grid-cols-1 gap-12 sm:gap-24 max-w-[800px] mx-auto items-center justify-around">
                    <div class="hidden md:flex flex-col gap-24 col-span-1">
                        <div class="flex flex-row justify-start items-start gap-4">
                            <span class="font-secondary text-[#8BDCF7] text-[60px] leading-[40px] flex-0 min-w-[50px]">1</span>
                            <div class="flex-1 flex flex-col gap-6">
                                <h3 class="font-secondary text-[#0A5A75] text-[36px] leading-[46px]">{{ t('forParents.question_1.question') }}</h3>
                                <ol class="list-decimal text-[#012C3B]">
                                    <li class="ml-5 mb-2">{{ t('forParents.question_1.answer_1') }}</li>
                                    <li class="ml-5 mb-2">{{ t('forParents.question_1.answer_2') }}</li>
                                    <li class="ml-5 mb-2">{{ t('forParents.question_1.answer_3') }}</li>
                                    <li class="ml-5 mb-2">{{ t('forParents.question_1.answer_4') }}</li>
                                    <li class="ml-5 mb-2">{{ t('forParents.question_1.answer_5') }}</li>
                                    <li class="ml-5">{{ t('forParents.question_1.answer_6') }}</li>
                                </ol>
                            </div>
                        </div>
                        <div class="flex flex-row justify-start items-start gap-4">
                            <span class="font-secondary text-[#8BDCF7] text-[60px] leading-[40px] flex-0 min-w-[50px]">2</span>
                            <div class="flex-1 flex flex-col gap-6">
                                <h3 class="font-secondary text-[#0A5A75] text-[36px] leading-[46px]">{{ t('forParents.question_2.question') }}</h3>
                                <p class="text-[#012C3B]">{{ t('forParents.question_2.answer') }}</p>
                            </div>
                        </div>
                        <div class="flex flex-row justify-start items-start gap-4">
                            <span class="font-secondary text-[#8BDCF7] text-[60px] leading-[40px] flex-0 min-w-[50px]">3</span>
                            <div class="flex-1 flex flex-col gap-6">
                                <h3 class="font-secondary text-[#0A5A75] text-[36px] leading-[46px]">{{ t('forParents.question_3.question') }}</h3>
                                <ul class="list-image-[url('/images/for-parents/bullet.svg')] text-[#012C3B]">
                                    <li class="ml-5 mb-2">{{ t('forParents.question_3.answer_1') }}</li>
                                    <li class="ml-5 mb-2">{{ t('forParents.question_3.answer_2') }}</li>
                                    <li class="ml-5 mb-2">{{ t('forParents.question_3.answer_3') }}</li>
                                    <li class="ml-5 mb-2">{{ t('forParents.question_3.answer_4') }}</li>
                                    <li class="ml-5">{{ t('forParents.question_3.answer_5') }}</li>
                                </ul>
                            </div>
                        </div>
                        <div class="flex flex-row justify-start items-start gap-4">
                            <span class="font-secondary text-[#8BDCF7] text-[60px] leading-[40px] flex-0 min-w-[50px]">4</span>
                            <div class="flex-1 flex flex-col gap-6">
                                <h3 class="font-secondary text-[#0A5A75] text-[36px] leading-[46px]">{{ t('forParents.question_4.question') }}</h3>
                                <div>
                                    <p class="text-[#012C3B] mb-2">{{ t('forParents.question_4.answer_1') }}</p>
                                    <p class="text-[#012C3B] mb-2" v-html="t('forParents.question_4.answer_2')"></p>
                                    <p class="text-[#012C3B]" v-html="t('forParents.question_4.answer_3')"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="md:hidden col-span-1">
                        <UAccordion
                            v-model="openItems"
                            :items="items"
                            trailing-icon="lucide:chevron-down"
                            :ui="{
                              trigger: 'text-[#0A5A75]',
                              trailingIcon: 'text-[#2CA2C9]'
                            }"
                        >
                            <template #content="{ item }">
                                <div v-html="item.content"></div>
                            </template>
                        </UAccordion>
                    </div>
                    <div class="col-span-1 relative max-w-[800px] mx-auto">
                        <div class="for-parents-text-cloud-top bg-[#ffffff] flex justify-center items-center py-4 px-8 lg:px-24 w-full">
                            <p class="text-center font-bold text-[#2CA2C9] text-[14px] leading-[21px] sm:text-[26px] sm:leading-[36px]" v-html="t('forParents.cloud')"></p>
                        </div>
                        <NuxtImg src="/images/for-parents/text-illustration-3.svg" alt="Illustracija" class="lg:hidden w-[50px] h-auto absolute top-[70%] right-[87%]" />
                    </div>
                    <div class="col-span-1 relative max-w-[800px] mx-auto flex flex-col items-center gap-8">
                        <UButton v-if="auth.user != null" :href="localePath('moj-racun-moji-vodici')">{{ t('forParents.buttonMyGuides')}}</UButton>
                        <UButton variant="outline" :href="localePath('vodici')">{{ t('forParents.buttonShop')}}</UButton>
                    </div>
                </div>
            </UContainer>
        </div>
        <NuxtImg src="/images/for-parents/text-illustration-1.svg" alt="Illustracija" class="hidden md:block md:w-[200px] xl:w-[300px] h-auto absolute top-6 lg:top-[20%] -right-[100px] lg:right-0" />
        <NuxtImg src="/images/for-parents/text-illustration-1-mobile.svg" alt="Illustracija" class="md:hidden w-[42px] h-auto absolute -top-6 right-4" />
        <NuxtImg src="/images/for-parents/text-illustration-2.svg" alt="Illustracija" class="hidden lg:block w-[150px] xl:w-[250px] h-auto absolute top-[50%] left-0" />
        <NuxtImg src="/images/for-parents/text-illustration-4.svg" alt="Illustracija" class="hidden lg:block w-[160px] h-auto absolute bottom-70 right-0" />
        <svg width="0" height="0" style="position:absolute">
            <defs>
                <clipPath id="for-parents-texts-bg-cloud-top" clipPathUnits="objectBoundingBox">
                    <path d="M0.0786 0 L0.9207 0 C0.9683 0 1 0.1465 0.9986 0.311 L0.981 0.7625 C0.9755 0.8985 0.9429 1 0.9036 1 L0.1187 1 C0.0843 1 0.0539 0.9213 0.0437 0.8075 L0.0036 0.3555 C-0.0121 0.1791 0.0256 0 0.0786 0 Z" />
                </clipPath>
            </defs>
        </svg>
        <div class="w-full pb-50 sm:pb-60 bg-[#edf7fa]"></div>
    </section>
</template>

<style scoped>
.for-parents-text-cloud-top {
    aspect-ratio: 3;
    clip-path: url(#for-parents-texts-bg-cloud-top);
}
.font-secondary {
    font-family: "Quicksand", "sans-serif";
}
</style>
